import React, { useEffect, useState, createElement } from 'react';
import { Link } from 'react-router-dom';
import { supabase, SubscriberRow } from '../lib/supabase';
function formatDate(iso: string) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).toLowerCase();
  } catch {
    return '';
  }
}
export function Subscribers() {
  const [subscribers, setSubscribers] = useState<SubscriberRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  useEffect(() => {
    const fetchSubscribers = async () => {
      setIsLoading(true);
      const {
        data,
        error
      } = await supabase.from('subscribers').select('*').order('created_at', {
        ascending: false
      });
      if (error) {
        setErrorMsg('could not load subscribers.');
        setSubscribers([]);
      } else {
        setSubscribers(data || []);
      }
      setIsLoading(false);
    };
    fetchSubscribers();
  }, []);
  const handleExportCsv = () => {
    if (subscribers.length === 0) return;
    const header = 'email,created_at';
    const rows = subscribers.map(s => `${s.email},${s.created_at}`).join('\n');
    const csv = `${header}\n${rows}`;
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };
  return <main className="relative min-h-screen w-full bg-[#f5f5f5] px-6 py-6 text-black md:px-10 md:py-10" style={{
    fontFamily: 'Helvetica, "Helvetica Neue", Arial, "Arial Nova", sans-serif'
  }} data-id="element-267">
      {/* Header — matches the rest of the site */}
      <header className="flex w-full items-start justify-between text-sm leading-tight" data-id="element-268">
        <Link to="/" className="lowercase hover:opacity-60" data-id="element-269">
          lennon cripe
        </Link>

        <nav className="flex flex-col items-start text-left" data-id="element-270">
          <Link to="/music" className="lowercase hover:opacity-60" data-id="element-271">
            catalog
          </Link>
          <Link to="/tour" className="lowercase hover:opacity-60" data-id="element-272">
            tour
          </Link>
          <Link to="/shop" className="lowercase hover:opacity-60" data-id="element-273">
            shop
          </Link>
          <Link to="/guestbook" className="lowercase hover:opacity-60" data-id="element-274">
            guestbook
          </Link>
        </nav>

        <a href="mailto:info@weedwaster.com" className="lowercase hover:opacity-60" data-id="element-275">
          contact
        </a>
      </header>

      {/* Page title + actions */}
      <section className="mt-20 flex w-full flex-col items-start text-sm md:mt-24" data-id="element-276">
        <p className="mb-2 font-bold lowercase" data-id="element-277">
          subscribers ({subscribers.length})
        </p>

        <div className="mb-6 flex items-center gap-6" data-id="element-278">
          <button onClick={handleExportCsv} disabled={subscribers.length === 0} className="lowercase hover:opacity-60 disabled:opacity-30" data-id="element-279">
            export csv
          </button>
        </div>

        {/* List */}
        {isLoading ? <p className="lowercase text-black/50" data-id="element-280">loading...</p> : errorMsg ? <p className="lowercase text-black/50" data-id="element-281">{errorMsg}</p> : subscribers.length === 0 ? <p className="lowercase" data-id="element-282">no subscribers yet.</p> : <div className="flex w-full max-w-2xl flex-col gap-1" data-id="element-283">
            {subscribers.map(s => <div key={s.id} className="flex w-full items-center justify-between" data-id="element-284">
                <span className="lowercase" data-id="element-285">
                  {s.email}
                  <span className="ml-3 text-black/40" data-id="element-286">
                    {formatDate(s.created_at)}
                  </span>
                </span>
              </div>)}
          </div>}

        <p className="mt-12 max-w-xl text-xs lowercase text-black/40" data-id="element-287">
          to remove subscribers, manage them directly from the supabase
          dashboard under the "subscribers" table.
        </p>
      </section>

      <div className="h-24" data-id="element-288" />
    </main>;
}